import { Link } from "react-router-dom";
import { BACKEND_URL } from "@/lib/api";
import { FanContentNotice } from "@/components/layout/FanContentNotice";

export function Footer() {
  return (
    <footer className="relative z-10 mt-24 border-t border-amber-900/30 bg-[#0B0D12]" data-testid="site-footer">
      <div className="container-x grid gap-8 py-12 md:grid-cols-12">
        <div className="md:col-span-6">
          <p className="font-display text-lg text-amber-100">The Planar Foundry</p>
          <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-copper-300/80">Forge Your Cards. Build Your Legends. Shape the Multiverse.</p>
          <p className="mt-3 max-w-md text-sm text-slate-400">
            A free community workshop for fan-made Magic: The Gathering cards. Official card data and images are provided by Scryfall.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-3">Explore</p>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/library" className="hover:text-amber-200" data-testid="footer-library-link">Card library</Link></li>
            <li><Link to="/sets" className="hover:text-amber-200" data-testid="footer-sets-link">Custom sets</Link></li>
            <li><Link to="/card-backs" className="hover:text-amber-200" data-testid="footer-card-backs-link">Card backs</Link></li>
            <li><Link to="/roadmap" className="hover:text-amber-200" data-testid="footer-roadmap-link">Roadmap</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-3">Developers</p>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/developers" className="hover:text-amber-200" data-testid="footer-developers-link">Developer guide</Link></li>
            <li><a href={`${BACKEND_URL}/api/docs`} target="_blank" rel="noreferrer" className="hover:text-amber-200" data-testid="footer-api-docs-link">API reference (OpenAPI)</a></li>
            <li><a href={`${BACKEND_URL}/api/openapi.json`} target="_blank" rel="noreferrer" className="hover:text-amber-200" data-testid="footer-openapi-json-link">openapi.json</a></li>
          </ul>
        </div>
      </div>
      <div className="container-x border-t border-amber-900/20 py-5"><FanContentNotice /></div>
    </footer>
  );
}
